"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Calculator_exports = {};
__export(Calculator_exports, {
  default: () => Calculator_default
});
module.exports = __toCommonJS(Calculator_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.4414 2.75C15.6107 2.75 15.7539 2.80859 15.8711 2.92578C16.0013 3.02995 16.0729 3.16667 16.0859 3.33594L16.1055 3.41406V16.7344C16.1055 16.9036 16.0469 17.0534 15.9297 17.1836C15.8125 17.3138 15.6758 17.3854 15.5195 17.3984H15.4414H5.44141C5.27214 17.3984 5.1224 17.3464 4.99219 17.2422C4.875 17.125 4.80339 16.9883 4.77734 16.832V16.7344V3.41406C4.77734 3.24479 4.82943 3.10156 4.93359 2.98438C5.05078 2.85417 5.19401 2.77604 5.36328 2.75H5.44141H15.4414ZM14.7578 7.41797H6.10547V16.0703H14.7578V7.41797ZM8.48828 13.4336C8.56641 13.4336 8.63802 13.4596 8.70312 13.5117C8.76823 13.5638 8.80729 13.6289 8.82031 13.707V13.7656V15.1523C8.82031 15.2305 8.79427 15.3021 8.74219 15.3672C8.6901 15.4323 8.625 15.4714 8.54688 15.4844H8.48828H7.10156C7.02344 15.4844 6.95182 15.4583 6.88672 15.4062C6.83464 15.3542 6.79557 15.2891 6.76953 15.2109V15.1523V13.7656C6.76953 13.6875 6.79557 13.6224 6.84766 13.5703C6.89974 13.5052 6.96484 13.4596 7.04297 13.4336H7.10156H8.48828ZM9.73828 13.4336H11.125C11.2031 13.4336 11.2747 13.4596 11.3398 13.5117C11.4049 13.5638 11.444 13.6289 11.457 13.707V13.7656V15.1523C11.457 15.2305 11.431 15.3021 11.3789 15.3672C11.3268 15.4323 11.2682 15.4714 11.2031 15.4844H11.125H9.73828C9.66016 15.4844 9.58854 15.4583 9.52344 15.4062C9.47135 15.3542 9.4388 15.2891 9.42578 15.2109L9.40625 15.1523V13.7656C9.40625 13.6875 9.43229 13.6224 9.48438 13.5703C9.53646 13.5052 9.60156 13.4596 9.67969 13.4336H9.73828ZM13.7617 10.7188C13.8529 10.7188 13.931 10.7513 13.9961 10.8164C14.0612 10.8815 14.0938 10.9596 14.0938 11.0508V15.1523C14.0938 15.2435 14.0612 15.3216 13.9961 15.3867C13.931 15.4518 13.8529 15.4844 13.7617 15.4844H12.375C12.2839 15.4844 12.2057 15.4518 12.1406 15.3867C12.0755 15.3216 12.043 15.2435 12.043 15.1523V11.0508C12.043 10.9596 12.0755 10.8815 12.1406 10.8164C12.2057 10.7513 12.2839 10.7188 12.375 10.7188H13.7617ZM8.48828 10.7188C8.56641 10.7188 8.63802 10.7448 8.70312 10.7969C8.76823 10.849 8.80729 10.9141 8.82031 10.9922V11.0508V12.4375C8.82031 12.5156 8.79427 12.5872 8.74219 12.6523C8.6901 12.7044 8.625 12.7435 8.54688 12.7695H8.48828H7.10156C7.02344 12.7695 6.95182 12.7435 6.88672 12.6914C6.83464 12.6393 6.79557 12.5742 6.76953 12.4961V12.4375V11.0508C6.76953 10.9727 6.79557 10.9076 6.84766 10.8555C6.89974 10.7904 6.96484 10.7448 7.04297 10.7188H7.10156H8.48828ZM11.125 10.7188C11.2031 10.7188 11.2747 10.7448 11.3398 10.7969C11.4049 10.849 11.444 10.9141 11.457 10.9922V11.0508V12.4375C11.457 12.5156 11.431 12.5872 11.3789 12.6523C11.3268 12.7044 11.2682 12.7435 11.2031 12.7695H11.125H9.73828C9.66016 12.7695 9.58854 12.7435 9.52344 12.6914C9.47135 12.6393 9.4388 12.5742 9.42578 12.4961L9.40625 12.4375V11.0508C9.40625 10.9727 9.43229 10.9076 9.48438 10.8555C9.53646 10.7904 9.60156 10.7448 9.67969 10.7188H9.73828H11.125ZM8.48828 8.00391C8.56641 8.00391 8.63802 8.02995 8.70312 8.08203C8.76823 8.13411 8.80729 8.19922 8.82031 8.27734V8.33594V9.72266C8.82031 9.80078 8.79427 9.8724 8.74219 9.9375C8.6901 9.98958 8.625 10.0286 8.54688 10.0547H8.48828H7.10156C7.02344 10.0547 6.95182 10.0286 6.88672 9.97656C6.83464 9.92448 6.79557 9.85938 6.76953 9.78125V9.72266V8.33594C6.76953 8.25781 6.79557 8.1862 6.84766 8.12109C6.89974 8.05599 6.96484 8.01693 7.04297 8.00391H7.10156H8.48828ZM11.125 8.00391C11.2031 8.00391 11.2747 8.02995 11.3398 8.08203C11.4049 8.13411 11.444 8.19922 11.457 8.27734V8.33594V9.72266C11.457 9.80078 11.431 9.8724 11.3789 9.9375C11.3268 9.98958 11.2682 10.0286 11.2031 10.0547H11.125H9.73828C9.66016 10.0547 9.58854 10.0286 9.52344 9.97656C9.47135 9.92448 9.4388 9.85938 9.42578 9.78125L9.40625 9.72266V8.33594C9.40625 8.25781 9.43229 8.1862 9.48438 8.12109C9.53646 8.05599 9.60156 8.01693 9.67969 8.00391H9.73828H11.125ZM13.7617 8.00391C13.8398 8.00391 13.9115 8.02995 13.9766 8.08203C14.0417 8.13411 14.0807 8.19922 14.0938 8.27734V8.33594V9.72266C14.0938 9.80078 14.0677 9.8724 14.0156 9.9375C13.9766 9.98958 13.918 10.0286 13.8398 10.0547H13.7617H12.375C12.2969 10.0547 12.2253 10.0286 12.1602 9.97656C12.1081 9.92448 12.0755 9.85938 12.0625 9.78125L12.043 9.72266V8.33594C12.043 8.25781 12.069 8.1862 12.1211 8.12109C12.1732 8.05599 12.2383 8.01693 12.3164 8.00391H12.375H13.7617ZM14.7578 4.07812H6.10547V6.08984H14.7578V4.07812Z",
      fill: "currentColor"
    }
  )
);
const SvgCalculator = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Calculator_default = SvgCalculator;
